import { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { useUpdateCYAvailability } from "../../api/CodeYellowAvailabilityApi";
import Switch from "../Switch/Switch";
import { useUserData } from "../../api/UserApi";
import { RespondingProvider } from "../../types/CodeYellow";
import { getIsRespondingProviderOptedIn } from "../../hooks/useRespondingProvidersCount";

interface Props {
  codeYellowId: string;
  respondingProviders: RespondingProvider[];
}

export const CodeYellowAvailable = ({ codeYellowId, respondingProviders = [] }: Props) => {
  const { data: currentUser } = useUserData();

  const respondingProvider = respondingProviders.find(
    ({ user: { id } }) => id === currentUser?.id,
  );

  const initialAvailable =
    currentUser != null ? getIsRespondingProviderOptedIn(respondingProvider) : false;
  
  const [available, setAvailable] = useState(initialAvailable);
  
  useEffect(() => {
    if (currentUser) {
      const newRespondingProvider = respondingProviders.find(
        ({ user: { id } }) => id === currentUser.id,
      );
      setAvailable(getIsRespondingProviderOptedIn(newRespondingProvider));
    }
  }, [respondingProviders, currentUser]);

  const { mutate: updateAvailability, isPending } = useUpdateCYAvailability();

  const handleAvailabilityChange = () => {
    setAvailable(!available);
    
    updateAvailability({
      codeYellowId,
      userId: currentUser!.id,
      optIn: !available,
    });
  };

  return (
    <Box display="flex" width="16" alignItems="center">
      <Switch
        isToggled={available}
        onToggle={() => handleAvailabilityChange()}
        disabled={isPending}
      />
    </Box>
  );
};